import styled from "styled-components";
import {Badge} from "antd";

type ContainerType = {
    background: string;
};

type iconTab = {
    color: string;
}

type BadgeStyle = {
    colorcount: string;
    bordercolor: string;
    textfontsizesm: number;
}

type TabType = {
    height: number;
}

type ContentTabsType = {
    width: number;
}

export const Container = styled.div<ContainerType>`
  display: flex;
  flex: 1;
  height: calc(100vh - 61px);
  flex-direction: column;
  overflow: hidden;
  background: ${(props) => props.background};
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
`;
export const ContentTabsAndNotifications = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
`;

export const ContentTabs = styled.div<ContentTabsType>`
  width: ${(props) => `${props.width}px`};
  min-width: ${(props) => `${props.width}px`};
  max-width: ${(props) => `${props.width}px`};
`;

export const Tab = styled.div<TabType>`
    font-size: 14px;
    margin: 0 2px;
    display: flex;
    flex-direction: row;
    height: ${(props) => `${props.height}px`};
`;

export const ContentTab = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
`;

export const IconTab = styled.i<iconTab>`
  font-size: 12px;
  color: ${props => props.color};
  margin-right: 2px;
`;


export const BadgeStyled = styled(Badge)<BadgeStyle>`
  .ant-badge-multiple-words {
    padding: 0 4px;
  }

  .ant-badge-count {
    color: ${props => props.colorcount};
    box-shadow: 0 0 0 1.5px ${props => props.bordercolor};
  }

  .ant-badge-count-sm {
    line-height: ${props => props.textfontsizesm}px;
  }
`;

export const ContentLabel = styled.div`
    display: flex;
    flex-direction: row;
`;

type InternalChatTabWrapperType = {
    disabled: boolean;
    disabledbackground: string;
}

export const InternalChatTabWrapper = styled.div<InternalChatTabWrapperType>`
    position: relative;
    display: flex;
    flex: 1;
    flex-direction: row;
    align-items: flex-end;
    justify-content: center;
    background: ${(props) => props.disabled ? props.disabledbackground : 'transparent'};
    padding: 0 8px 0 8px;
    border-radius: 5px;
`;

type LockBadgeType = {
    color: string;
}

export const LockBadge = styled.div<LockBadgeType>`
    position: absolute;
    top: 2px;
    right: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${(props) => props.color};
    z-index: 1;
`;
